import { useState, useCallback } from 'react';
import { useAppDispatch } from '../../store/slice';
import { FtuxSlice } from '../../store/slice/Ftux';
import { TutorialType } from '../../api/models';

export const useDynamicFtuxRestart = (tutorialType?: TutorialType) => {
	const dispatch = useAppDispatch();
	const [manualRestartTrigger, setManualRestartTrigger] = useState(0);

	const restartTutorial = useCallback(() => {
		if (!tutorialType) {
			console.warn('useDynamicFtuxRestart: tutorialType is required');
			return;
		}

		// Reset tutorial in Redux (no API call) to allow restart
		dispatch(FtuxSlice.actions.resetTutorial(tutorialType));
		// Increment trigger to restart DynamicFtux
		setManualRestartTrigger((prev) => prev + 1);
	}, [tutorialType, dispatch]);

	return {
		restartTutorial,
		manualRestartTrigger
	};
};
